import React from "react";

const NotesPageLoggedOutView = () => {
  return <div>Please Login to create notes</div>;
};

export default NotesPageLoggedOutView;
